module.exports = __webpack_public_path__ + "static/media/megapipe.a0f5fce4.svg";